import { actions, reducer } from './reducer';
import * as selectors from './selector';
export const authUserModel = { actions, reducer, selectors };
